import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=765f536b"
import script from "./Contract.vue?vue&type=script&lang=js"
export * from "./Contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports